import * as React from 'react';

export interface DelayedRenderProps extends React.Props<{}> {
  delay?: number;
}

export interface DelayedRenderState {
  isRendered: boolean;
}

/**
 * Utility component for delaying the render of a child component after a given delay. This component
 * requires a single child component; don't pass in many components. Wrap multiple components in a DIV
 * if necessary.
 *
 */
export class DelayedRender extends React.Component<DelayedRenderProps, DelayedRenderState> {
  static defaultProps = {
    delay: 0
  };

  private _timeoutId: any;

  constructor(props: DelayedRenderProps) {
    super(props);
    this.state = {
      isRendered: false
    };
  }

  componentDidMount(): void {
    let { delay } = this.props;
    this._timeoutId = setTimeout(() => {
      this.setState({
        isRendered: true
      });
    }, delay);
  }

  componentWillUnmount(): void {
    if (this._timeoutId) {
      clearTimeout(this._timeoutId);
    }
  }

  render() {
    return this.state.isRendered ? React.Children.only(this.props.children) : null;
  }
}
